var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import mpStorage from "@/services/LocalStorage";
import ErrorSender from "@/api/RequestAxios/SendErrorToGraylog";
import { emitOtpRequest } from "@/api/RequestAxios/OtpEvents";
import { ProtectedActionError } from "@/api/RequestAxios/ProtectedActionError";
var REQUEST_TIMEOUT = 8000;
export var beforeRequestHandler = function (config) {
    return config;
};
export var requestErrorHandler = function (error, instance) {
    var _a, _b, _c, _d, _e, _f;
    if (error.request &&
        !(error.code === "ECONNABORTED" &&
            error.message.indexOf(REQUEST_TIMEOUT.toString()) > -1)) {
        ErrorSender.send({
            message: "Request Error",
            context: {
                url: (_a = error.config) === null || _a === void 0 ? void 0 : _a.url,
                code: error.code,
                stage: global.UI_ENV,
                error: "".concat(error.stack),
                request: "".concat(JSON.stringify(error.request)),
                response: "".concat(JSON.stringify((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta)),
                message: error.message
            }
        });
    }
    if (error.response) {
        ErrorSender.send({
            message: "".concat(error.response.statusText),
            context: {
                url: (_d = error.config) === null || _d === void 0 ? void 0 : _d.url,
                code: error.code,
                stage: global.UI_ENV,
                error: "".concat(error.stack),
                response: "".concat(JSON.stringify(error.response)),
                request: "".concat(JSON.stringify(error.request)),
                message: error.message
            }
        });
        if (error.response.status === 401) {
            mpStorage.clearCacheAuthenticate();
            window.location.href = "/auth/login";
        }
        if (error.response.status === 403 &&
            ((_f = (_e = error.response.data) === null || _e === void 0 ? void 0 : _e.meta) === null || _f === void 0 ? void 0 : _f.otp_action)) {
            if (!instance || !error.config)
                return Promise.reject(error);
            return new Promise(function (resolve, reject) {
                var _a, _b, _c;
                var retryRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, retryError_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, instance(error.config)];
                            case 1:
                                response = _a.sent();
                                resolve(response);
                                return [3 /*break*/, 3];
                            case 2:
                                retryError_1 = _a.sent();
                                reject(retryError_1);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); };
                var otpAction = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.otp_action;
                if (otpAction) {
                    emitOtpRequest({
                        action: otpAction,
                        retryRequest: retryRequest,
                        onCancel: function () {
                            reject(new ProtectedActionError());
                        }
                    });
                }
                else {
                    reject(new ProtectedActionError());
                }
            });
        }
        if (error.response.status === 401) {
            mpStorage.clearCacheAuthenticate();
            // Use dynamic import to avoid circular dependency
            import("../auth/authHub").then(function (_a) {
                var loginViaAuth360 = _a.loginViaAuth360;
                loginViaAuth360({ prompt: true });
            });
        }
    }
    return Promise.reject(error);
};
//# sourceMappingURL=data:application/json;base64,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